/**
 * iOS 键盘把订阅弹窗上半截（头图）挤出可见区。
 *
 * 不要钉「白色表单块」：邮箱框的父级往往只是下半截，
 * 钉它等于把头图留在键盘坐标系外。要钉包含图片的整张卡。
 *
 * 键盘弹出后：整卡贴 visualViewport 顶部，高度不超过可见区，
 * 禁止页面/卡片被 scroll-into-view 把头图滚走。
 */
(function () {
  if (window.__plIosPopupKeyboardFix) return;
  window.__plIosPopupKeyboardFix = true;

  var KEYBOARD_RATIO = 0.85;
  var panel = null;
  var savedCss = '';
  var savedScrollY = 0;
  var watchTimer = null;

  function isMobile() {
    return window.matchMedia('(max-width: 767px)').matches;
  }

  function viewport() {
    return window.visualViewport || null;
  }

  function keyboardOpen() {
    var vv = viewport();
    if (!vv) return false;
    return vv.height < window.innerHeight * KEYBOARD_RATIO;
  }

  function isEmailLike(el) {
    if (!el || !el.tagName) return false;
    var tag = el.tagName.toUpperCase();
    if (tag !== 'INPUT' && tag !== 'TEXTAREA') return false;
    var type = String(el.type || el.getAttribute('type') || 'text').toLowerCase();
    if (type === 'email') return true;
    if (type && type !== 'text' && type !== 'search') return false;
    var blob = [
      el.placeholder,
      el.getAttribute('placeholder'),
      el.name,
      el.id,
      el.getAttribute('aria-label')
    ]
      .join(' ')
      .toLowerCase();
    return /email|e-mail|邮件|邮箱|mail/.test(blob);
  }

  function inPopupLayer(el) {
    if (!el || !el.closest) return null;
    return (
      el.closest('.klaviyo-form') ||
      el.closest('[class*="klaviyo-form"]') ||
      el.closest('[class*="kl-private"]') ||
      el.closest('.needsclick') ||
      el.closest('[role="dialog"]') ||
      el.closest('[aria-modal="true"]')
    );
  }

  function findCard(fromEl) {
    var vw = window.innerWidth;
    var vh = window.innerHeight;
    var el = fromEl;
    var best = null;
    var bestScore = -1;

    while (el && el !== document.body) {
      var style = window.getComputedStyle(el);
      var rect = el.getBoundingClientRect();
      var posed = style.position === 'fixed' || style.position === 'absolute';
      var fullBleed = rect.width >= vw * 0.92 && rect.height >= vh * 0.85;
      var cardSized = rect.width >= vw * 0.5 && rect.height >= 160 && !fullBleed;

      if (cardSized) {
        var hasImg = !!(el.querySelector && el.querySelector('img'));
        var score = rect.height + (hasImg ? 400 : 0) + (posed ? 80 : 0);
        if (score >= bestScore) {
          best = el;
          bestScore = score;
        }
      }
      el = el.parentElement;
    }

    return best;
  }

  function restore() {
    if (panel) {
      panel.setAttribute('style', savedCss);
    }
    panel = null;
    savedCss = '';
    if (watchTimer) {
      clearInterval(watchTimer);
      watchTimer = null;
    }
  }

  function isPinningActive() {
    return !!panel;
  }

  function freezePageScroll() {
    if (!isPinningActive()) return;
    try {
      window.scrollTo(0, savedScrollY);
    } catch (e) {}
  }

  function pin(focusEl) {
    var vv = viewport();
    if (!vv || !focusEl) return;
    var card = findCard(focusEl);
    if (!card) return;

    if (panel !== card) {
      if (panel) {
        panel.setAttribute('style', savedCss);
      }
      panel = card;
      savedCss = card.getAttribute('style') || '';
    }

    var pad = 8;
    var top = Math.round(vv.offsetTop + pad);
    var width = vv.width;
    var height = Math.max(160, Math.floor(vv.height - pad * 2));
    var maxW = Math.min(Math.floor(width - pad * 2), 420);
    var left = Math.round(vv.offsetLeft + width / 2);

    // 贴可见区顶部：头图留在最上，不再用 translateY(-50%) 居中（矮视口会裁掉上半）
    card.style.setProperty('position', 'fixed', 'important');
    card.style.setProperty('top', top + 'px', 'important');
    card.style.setProperty('left', left + 'px', 'important');
    card.style.setProperty('right', 'auto', 'important');
    card.style.setProperty('bottom', 'auto', 'important');
    card.style.setProperty('transform', 'translateX(-50%)', 'important');
    card.style.setProperty('width', maxW + 'px', 'important');
    card.style.setProperty('max-width', maxW + 'px', 'important');
    card.style.setProperty('max-height', height + 'px', 'important');
    card.style.setProperty('height', 'auto', 'important');
    card.style.setProperty('margin', '0', 'important');
    card.style.setProperty('z-index', '2147483646', 'important');
    card.style.setProperty('box-sizing', 'border-box', 'important');
    card.style.setProperty('overflow-x', 'hidden', 'important');
    card.style.setProperty('overflow-y', 'auto', 'important');
    card.style.setProperty('-webkit-overflow-scrolling', 'touch', 'important');

    freezePageScroll();
    if (card.scrollTop) card.scrollTop = 0;
  }

  function sync() {
    if (!isMobile()) {
      restore();
      return;
    }
    var ae = document.activeElement;
    if (!keyboardOpen() || !isEmailLike(ae) || !inPopupLayer(ae)) {
      restore();
      return;
    }
    pin(ae);
  }

  function onFocusIn(evt) {
    var t = evt.target;
    if (!isEmailLike(t) || !inPopupLayer(t)) return;
    savedScrollY = window.scrollY || window.pageYOffset || 0;
    setTimeout(sync, 40);
    setTimeout(sync, 200);
    setTimeout(sync, 400);
    if (!watchTimer) watchTimer = setInterval(sync, 100);
  }

  function onFocusOut() {
    setTimeout(sync, 80);
    setTimeout(sync, 320);
  }

  document.addEventListener('focusin', onFocusIn, true);
  document.addEventListener('focusout', onFocusOut, true);
  if (window.visualViewport) {
    window.visualViewport.addEventListener('resize', sync);
    // 仅在弹窗已 pin 时锁滚动；iOS 正常页面滚动也会触发 visualViewport scroll
    window.visualViewport.addEventListener('scroll', function () {
      if (isPinningActive()) freezePageScroll();
      sync();
    });
  }
  window.addEventListener('resize', sync);
})();
